import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { isModelDeleteAsyncSuccessNotificationPayload } from "@/entities/broadcast-notification";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useAppNotification } from "@/modules/app-notification";
import { getModelApiKey } from "@/modules/model";
import { NotificationAsyncDeleteSuccessDescription } from "@/modules/notification/notification-async-delete";

export const useModelDeleteAsyncActionSuccess = () => {
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isModelDeleteAsyncSuccessNotificationPayload(payload)) return;

    const apiKey = getModelApiKey(payload.models[0].type);

    notify.success({
      key: payload.id,
      title: <NotificationAsyncDeleteSuccessDescription data={payload} />,
      duration: ONE_MINUTE_IN_SECONDS,
    });

    queryClient.invalidateQueries({
      queryKey: [apiKey, "list"],
    });

    invalidateNotifications("*");
  };

  return { runAction };
};
